module.exports = __webpack_public_path__ + "img/Mahmoud Abdelaziz.0c6a73b5.jpg";